import Analitics from "@/shared/Analitics";
import { MainTitle, HeaderVintageContainer  } from "./styles";
import LdjsonOrg from "@/shared/Schemas/Organization";
import LdjsonItemList from "@/shared/Schemas/ItemList";
import LdjsonNewsMediaOrg from "@/shared/Schemas/NewsMediaOrganization/index.js";
import LdjsonWebsite from "@/shared/Schemas/Website/index.js";
import LdjsonBreadcrumbList from "@/shared/Schemas/BreadcrumbList/index.js";
import { MetaTagsSubhome } from "@/shared/MetaTags";
import Meter from "@/shared/Meter/index.jsx";
import Autorefresh from "@/shared/Autorefresh/index.jsx";
import TemplateProvider from "@/context/Template/TemplateProvider.jsx";
import { useHome } from "./hooks/useHome";
import { HeaderVintage } from "../Nota/components/HeaderVintage";

const AniversaryPageBuilder = (props) => {
  const { formatContent, ...rest } = useHome(props);


  return (
    <TemplateProvider
      data={{ ...rest, content: formatContent }}
    >
      <MetaTagsSubhome />
      {!rest?.preview && (
        <>
          <Analitics />
          <LdjsonOrg />
          <LdjsonItemList />
          <LdjsonNewsMediaOrg />
          <LdjsonWebsite />
          <LdjsonBreadcrumbList />
          <HeaderVintageContainer>
            <HeaderVintage
              className="header-vintage"
              hamburguerMenu={false}
              containerClass={"home-vintage"}
            />
          </HeaderVintageContainer>
        </>
      )}
      <div>
        {formatContent?.h1MainTitle && <MainTitle>{formatContent?.h1MainTitle}</MainTitle>}
        {rest?.Pagegrowler.generateDOM(props, rest?.preview)}
      </div>
      {!rest?.preview && (
        <>
          {formatContent?.metaRefresh?.status && (
            <Autorefresh timerRefresh={formatContent?.metaRefresh?.timer} />
          )}
          <Meter />
        </>
      )}
    </TemplateProvider>
  );
};

export default AniversaryPageBuilder;
